module.exports = __webpack_public_path__ + "assets/1f4d99bf30b3dca5d9f897ea84035f08.png";